import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findSnapGoods= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-advert/v1/goods?`+params,
        method: 'GET'
    })
}
export const addSnapGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-advert/v1/goods`,
        method: 'POST',
        data: data
    })
}
export const updateSnapGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-advert/v1/goods`,
        method: 'PUT',
        data: data
    })
}
export const findProductGoodsById= (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/product/findProductGoodsById/${id}`,
        method: 'GET'
    })
}
export const updateSnapGoodsStatus = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-advert/v1/goods/${temp}`,
        method: 'PUT'
    })
}
export const deleteSnapGoods = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-advert/v1/goods/${temp}`,
        method: 'DELETE'
    })
}

